import {
	membershipsQuery,
	partnerSearchSchema,
	pickPartner,
	retailersQuery,
} from "@commerce/partner/meta";
import {
	PartnerScreen,
	PartnerSkeleton,
} from "@commerce/partner/PartnerScreen";
import { config } from "@repo/config";
import { AsyncBoundary } from "@shared/components/AsyncBoundary";
import { dehydrateForLoader, getServerQueryClient } from "@shared/lib/server";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_saas/app/_account/partner")({
	validateSearch: partnerSearchSchema,
	loaderDeps: ({ search }) => ({ partner: search.partner }),
	loader: async ({ deps }) => {
		const queryClient = getServerQueryClient();
		const { partners } = await queryClient.ensureQueryData(
			membershipsQuery(),
		);
		const partner = pickPartner(partners, deps.partner);
		// Only partner staff (and platform staff) have a console.
		if (!partner) {
			throw redirect({ to: "/app" });
		}
		await queryClient.ensureQueryData(retailersQuery(partner.id));
		return { dehydratedState: dehydrateForLoader(queryClient) };
	},
	head: () => ({ meta: [{ title: `Partner - ${config.appName}` }] }),
	component: PartnerPage,
});

function PartnerPage() {
	const { dehydratedState } = Route.useLoaderData();
	return (
		<AsyncBoundary
			fallback={<PartnerSkeleton />}
			dehydratedState={dehydratedState}
		>
			<PartnerScreen />
		</AsyncBoundary>
	);
}
